import { createSelector } from 'reselect';
import { getBiasharaFlexiState } from './index';
import { API_CALL_STATUS, FORM_STATUS } from '../../reducers/status';

export const getCompanyDetails = createSelector(getBiasharaFlexiState, (state) => state.companyDetails);

export const getApiStatus = createSelector(getCompanyDetails, (companyDetails) => companyDetails.apiCallStatus);

export const getIsApiPending = createSelector(
    getCompanyDetails,
    (companyDetails) => companyDetails.apiCallStatus === API_CALL_STATUS.PENDING
);

const makeGetCompanyDetailsField = (fieldName) =>
    createSelector(getCompanyDetails, (companyDetails) => companyDetails[fieldName]);

export const getCompanyDetailsForm = makeGetCompanyDetailsField('form');

export const getCompanyDetailsFormValid = createSelector(
    getCompanyDetails,
    (companyDetails) => companyDetails.formStatus === FORM_STATUS.VALID
);

const makeGetFieldForm = (fieldId) => createSelector(getCompanyDetailsForm, (form) => form[fieldId]);

export const getCompanyNameValue = makeGetFieldForm('companyName');
export const getEmailValue = makeGetFieldForm('email');
export const getMobileNumberValue = makeGetFieldForm('mobileNumber');
export const getKraPinNumberValue = makeGetFieldForm('kraPinNumber');
export const getCityValue = makeGetFieldForm('city');
export const getStreetAddressValue = makeGetFieldForm('streetAddress');
export const getBuildingValue = makeGetFieldForm('building');
export const getPostalCodeValue = makeGetFieldForm('postalCode');
export const getPostalBoxValue = makeGetFieldForm('postalBox');
export const getFirstNameValue = makeGetFieldForm('firstName');
export const getSurnameValue = makeGetFieldForm('lastName');
export const getIdPassportValue = makeGetFieldForm('idNumber');
export const getCompanyIdValue = makeGetFieldForm('companyId');
export const getQuoteIdValue = makeGetFieldForm('quoteId');
export const getReferredValue = makeGetFieldForm('referred');
